import { FirebaseError } from "firebase/app";
import { useCallback } from "react";
import Message, { PredefinedMessages } from "@hooks/useMessage";
import {
  isCancelledOauthPopupError,
  translateToastErrorMessage,
} from "@libs/utils/firebase/auth";
import { rollbar } from "@libs/utils/rollbar";

type ResultType = (err: unknown) => void;

export const useOauthErrorHandler = (): ResultType => {
  const { addMessage } = Message.useContainer();

  return useCallback(
    (err: unknown): void => {
      if (err instanceof FirebaseError) {
        if (isCancelledOauthPopupError(err)) {
          // ユーザーが自分でポップアップを閉じただけなのでエラー表示しない
          return;
        }
        rollbar?.error(err);
        addMessage(translateToastErrorMessage(err.code));
      } else {
        rollbar?.error(err instanceof Error ? err : new Error(String(err)));
        addMessage(PredefinedMessages.commonError);
      }
    },
    [addMessage]
  );
};

export default useOauthErrorHandler;
